import React from 'react'
import { Input } from '@shopflo/ui'
import { useDiscountForm } from './hooks/useDiscountForm'
import { CouponType, DiscountFieldPaths } from 'src/lib/types/discountsV2'
import FormErrorText from 'src/components/common/FormErrorText'
import { useLocale } from 'src/lib/hooks/useLocal'

const MaxUsesPerOrder = () => {
  const {
    state: { entitlement, errors },
    actions: { setFormState }
  } = useDiscountForm()
  const { t } = useLocale()

  if (entitlement.type === CouponType.SHIPPING) return null

  const maxUsesPerOrder = entitlement.maxUsesPerOrder

  const handleMaxUsesChange = (val: string) => {
    if (val === '') {
      setFormState({
        entitlement: {
          ...entitlement,
          maxUsesPerOrder: null
        }
      })
      return
    }

    let value = parseInt(val)

    if (value && value > 999999) {
      value = 999999
    }

    setFormState({
      entitlement: {
        ...entitlement,
        maxUsesPerOrder: value || null
      }
    })
  }

  return (
    <div className='flex flex-col'>
      <div className='flex  flex-col items-start w-full gap-3 py-3'>
        <span className='text-text-sm-semibold text-zinc-800'>{t('discounts_v2.repeat_upto')}</span>
        <div className='flex flex-col gap-2 w-[25%]'>
          <Input
            id='max-uses-per-order-input'
            value={maxUsesPerOrder ?? ''}
            onChange={e => handleMaxUsesChange(e.target.value)}
            type='number'
            min={1}
            dimension='md'
            variant='outline'
            placeholder={t('discounts_v2.no_limit') || 'No limit'}
            className='text-zinc-800 w-full'
            endAdornment={
              <div className='flex items-center gap-2 pl-2 whitespace-nowrap'>
                {maxUsesPerOrder ? (
                  <span className='text-text-sm-regular text-zinc-400'>{t('discounts_v2.times_per_order')}</span>
                ) : null}
              </div>
            }
          />
          <span className='text-text-xs-regular text-nowrap text-zinc-500'>
            {maxUsesPerOrder
              ? t('discounts_v2.max_uses_per_order_description', { count: maxUsesPerOrder })
              : t('discounts_v2.no_limit_description') || 'No limit on uses per order'}
          </span>
        </div>
      </div>

      <FormErrorText message={errors[DiscountFieldPaths.MAXUSES_PER_ORDER]} />
    </div>
  )
}

export default MaxUsesPerOrder
